import { Strings } from '@/resources';
import { Link, usePage } from '@inertiajs/react';
import type { PageProps } from '@/types';
import './footer.scss';

const language = Strings.footer;

export default function Footer({ withSideBar }: { withSideBar?: boolean }) {
  const { branding } = usePage<PageProps>().props;
  const copyrightName = branding.legal.copyright_name;

  return (
    <footer>
      <div className={`container ${withSideBar ? 'with-sidebar' : ''}`}>
        <div className='footer-content'>
          <div className='copyrights'>
            <p>
              {' '}
              &copy; {new Date().getFullYear()} {copyrightName} |{' '}
              {language.copyright_text}
            </p>
          </div>
          <div className='footer-menu'>
            <Link href={route('portal-info.security-statement')}>
              {language.security_statement}
            </Link>
            <Link href={route('portal-info.privacy-policy')}>
              {language.privacy_policy}
            </Link>
            <Link href={route('portal-info.terms')}>
              {language.terms_conditions}
            </Link>
            <Link href={route('portal-info.patent')}>
              {language.patent_information_text}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
